<div class="form-container" *ngIf="!isPasswordSet">
  <!-- password change section  -->
  <div class="inner-container-wrapper">
    <div class="titletext">
      {{'RESET_PASSWORD.TITLE_ENTER_NEW_PASSWORD' | translate}}
    </div>
    <p class="peratext-light pt16"> {{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_CHANGE_PROCEDURE' | translate}}
    </p>
    <div class="form_wrapper">
    <form id="passwordForm" class="custom-form" [formGroup]="resetPwdForm" (ngSubmit)="checkValidUser()" autocomplete="off" name="form" #changePwdForm="ngForm">
      <div class="input-control w-336 input-error-wrapper">
        <div class="input-cont">
          <input [ngClass]="(!isPasswordWeak && passwordRef.value) ? 'border-red': ''" autocomplete="off"
          [type]="showNewPassword ? 'text' : 'password'" id="newPassword" name="newPassword" class="control"
              (input)="checkPasswordStrength();"  placeholder="Password"
              (focusout)="onFocusLoose();checkPasswords();"
              (focus)="isPasswordWeak=true"
              maxlength="20" formControlName="newPassword" required
              appNoWhitespace #passwordRef>
            </div>
          <div class="text-red"
            *ngIf="(resetPwdForm.controls.newPassword.errors?.whitespace || resetPwdForm.controls.newPassword.errors?.required) && resetPwdForm.controls.newPassword.invalid && (resetPwdForm.controls.newPassword.touched)">
            Fill-in the field
        </div>
          <div class="text-red" *ngIf="(!isPasswordWeak && passwordRef.value)">Password didn't meet the requirements.
              Try again.</div>
      </div>
      <div class="input-control w-336 input-error-wrapper">
        <div class="input-cont">
          <input [ngClass]="(!isConfirmPassword && cnfpwdRef.value) ? 'border-red': ''" autocomplete="off"
          [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword" class="control" id="confirmPassword"
          placeholder="Confirm password"
              (input)="checkPasswords();" formControlName="confirmPassword" maxlength="20" appNoWhitespace #cnfpwdRef>
            </div>
          <div class="text-red" *ngIf="!isConfirmPassword && cnfpwdRef.value">
              Confirm password didn't match.
          </div>
          <div class="text-red"
            *ngIf="(resetPwdForm.controls.confirmPassword.errors?.whitespace || resetPwdForm.controls.confirmPassword.errors?.required) && resetPwdForm.controls.confirmPassword.invalid && (resetPwdForm.controls.confirmPassword.touched)">
            Fill-in the field
        </div>
      </div>

    <div class="pwdp-wrapper pt24">
      <span [ngClass]="!isMinlength ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_1' | translate}}</span>
      <span [ngClass]="!isLowerCase ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_2' | translate}}</span>
      <span [ngClass]="!isUpperCase ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_3' | translate}} </span>
      <span [ngClass]="!isOneDigit ? 'disabled': ''">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_4' | translate}}</span>
      <span [ngClass]="(!isSpecialChar || !wholePassword ? 'disabled': '')">{{'RESET_PASSWORD.UPDATE_PWD.PASSWORD_RULE.RULE_5' | translate}}</span>
    </div>
    
      <span class="bktologin pt24" (click)="helperService.goToOnlineBankingApp()"> {{'RESET_PASSWORD.UPDATE_PWD.BACK_TO_LOGIN' | translate}} </span>
      <button class="cp-btn cp-btn-primary cp-mt-24"  [attr.disabled]="(invalidPassword && isConfirmPassword && cnfpwdRef.value) ? null: 'true'"
      type="submit">
      {{'RESET_PASSWORD.UPDATE_PWD.BTN_UPDATE_PASSWORD' | translate}}</button>
   
  </form>
  </div>
  </div>
</div>
